<template>
  <div class="dashboard">
    <el-row>
      <el-col :span="24">
        <div class="info">
          <h1>网站概要</h1>
          <div>
            <router-link :to="{ name: 'postCreate' }">
              <el-button type="success">撰写新文章</el-button>
            </router-link>
            <router-link :to="{ name: 'optionGeneral' }">
              <el-button style="margin-left: 10px" type="info">系统设置</el-button>
            </router-link>
          </div>
        </div>
        <el-slider style="margin-top: 20px" v-model="sliderValue"></el-slider>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="margin-top:20px;">
      <el-col :span="10">
        <div class="recent">
          <el-tree
            :default-expand-all='true'
            style="border-width: 0px"
            :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: 'dashboard',
    data () {
      return {
        sliderValue: 100,
        data: [],
        defaultProps: {
          children: 'children',
          label: 'title'
        },
        list: []
      }
    },
    methods: {
      handleNodeClick (data, node, tree) {
        if (data.title !== '最近发布的文章') {
          this.$router.push({
            name: data.type === 'post' ? 'postCreate' : 'pageCreate',
            params: { id: data._id }
          })
        }
      }
    },
    mounted () {
      this.$store.dispatch('FETCH', {
        model: 'post',
        query: {
          select: {
            title: 1,
            type: 1
          },
          sort: {
            createdAt: -1
          },
          limit: 10
        }
      }).then(list => {
        this.data = [{
          title: '最近发布的文章',
          children: list
        }]
      })
    }
  }
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// Dashboard.vue?225f721f